import api from './axios';

export interface ElectronicInvoice {
    id: string;
    factusId: string | null;
    numero: string;
    cufe: string | null;
    tipoCliente: string;
    clienteNombre: string;
    clienteDocumento: string;
    clienteEmail: string | null;
    monto: number;
    descripcion: string | null;
    pdfUrl: string | null;
    xmlUrl: string | null;
    qrCode: string | null;
    estado: string;
    errorMensaje: string | null;
    paymentId: string | null;
    clientId: string | null;
    companyId: string;
    createdAt: string;
    client?: {
        id: string;
        nombre: string;
        numeroDocumento: string;
        email: string | null;
    } | null;
}

export interface ElectronicInvoiceStats {
    total: number;
    emitidas: number;
    errores: number;
    montoTotal: number;
}

export const getElectronicInvoices = async (): Promise<ElectronicInvoice[]> => {
    const response = await api.get('/electronic-invoices');
    return response.data;
};

export const getElectronicInvoiceStats = async (): Promise<ElectronicInvoiceStats> => {
    const response = await api.get('/electronic-invoices/stats');
    return response.data;
};

export const getElectronicInvoice = async (id: string): Promise<ElectronicInvoice> => {
    const response = await api.get(`/electronic-invoices/${id}`);
    return response.data;
};
